import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { submitVisitorEmail } from 'LiveBoard/modules/cta'
import { FormDialogContainer } from '../FormDialog'
import UnknownLead from './UnknownLead'
import KnownLead from './KnownLead'
import { CTA_FORM_NAMES } from '../constants'

class GetVisitorEmailContainer extends React.Component {
  constructor(props) {
    super(props)

    const { lead, initialValues } = props
    this.state = {
      isLeadUnknown: lead.anon_guest
    }
  }

  handleUnknownLeadClick = () => this.setState({ isLeadUnknown: true })

  render() {
    const {
      config, onCancel, onDone, area, submitVisitorEmail, lead, initialValues, ctaClass
    } = this.props

    return (
      <FormDialogContainer
        form={CTA_FORM_NAMES.getVisitorEmail}
        config={config}
        onSubmit={submitVisitorEmail}
        onCancel={onCancel}
        onDone={onDone}
        area={area}
        initialValues={initialValues}
        ctaClass={ctaClass} >
        {
          this.state.isLeadUnknown ?
            <UnknownLead /> :
            <KnownLead
              lead={lead}
              onLeadUnknownClick={this.handleUnknownLeadClick} />
        }
      </FormDialogContainer>
    )
  }
}

GetVisitorEmailContainer.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
  submitVisitorEmail: PropTypes.func.isRequired,
  lead: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  ctaClass: PropTypes.string
}

function mapStateToProps({ lead }) {
  return { lead, initialValues: { email: lead.email } }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ submitVisitorEmail }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GetVisitorEmailContainer)
